import React from 'react';
import { creatorBenefits } from '../data/mock';
import { Zap, Link as LinkIcon, Wallet, PiggyBank, Headphones, Rocket } from 'lucide-react';

const iconMap = {
  Zap,
  LinkIcon,
  Wallet,
  PiggyBank,
  HeadphonesIcon: Headphones,
  Rocket
};

const CreatorBenefits = () => {
  return (
    <section id="benefits" className="py-24 px-6 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-600 font-medium text-sm uppercase tracking-wider mb-4 block">
            For Creators
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Everything You Need to Monetize
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Focus on what you do best - creating content. We handle the rest.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {creatorBenefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 border border-slate-100 hover:border-emerald-200 transition-all hover:shadow-lg hover:shadow-emerald-50 group"
              >
                {/* Icon */}
                <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-5 group-hover:bg-emerald-100 group-hover:scale-110 transition-all">
                  {Icon && <Icon className="w-6 h-6 text-emerald-600" />}
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-slate-900 mb-2">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-sm">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CreatorBenefits;
